module.exports = __webpack_public_path__ + "img/bg-1.cf743e29.jpg";